import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
// Deep path, not the `modules/aiAgents` barrel (see AIConversations.tsx).
import { isEndpointMissingError } from "modules/aiAgents/helpers/lessons";

import { AiTurnDetail } from "../../aiConversations.types";
import { AI_CONVERSATIONS_QUERY_KEY } from "../../constants/enums";
import { requestGetTurnDetail } from "./getTurnDetail.request";

// What the assistant had in front of it for one customer message. Errors are
// shown by the correction panel itself: a 404 means the backend serving turns
// is not deployed yet, and the panel hides the feature instead of alerting.
const useGetTurnDetail = (
  conversationId: string | null,
  turnMessageId: string | null
) => {
  const query = useQuery<AiTurnDetail, ApiServiceError<ApiError>>({
    queryKey: [
      AI_CONVERSATIONS_QUERY_KEY,
      "turn",
      conversationId,
      turnMessageId
    ],
    queryFn: async () =>
      await requestGetTurnDetail({
        conversationId: conversationId!,
        turnMessageId: turnMessageId!
      }),
    enabled: Boolean(conversationId && turnMessageId),
    meta: { preventDefaultNotFound: true, preventDefaultBadRequest: true }
  });

  return {
    turn: query.data,
    isUnavailable: isEndpointMissingError(query.error),
    ...query
  };
};

export default useGetTurnDetail;
